<template>
  <section  id="network">
    <v-container class="pa-0">
      <v-layout row wrap class="align-items-center">
        <v-flex sm6 class="pr-4 hidden-sm-and-down"
          ><img
            src="https://amaze-assets.s3.us-west-1.amazonaws.com/files/networks/2024_2025_NECLN/NetworkDesign.svg"
          />
        </v-flex>
        <v-flex xs12 md6>
          <div class="col-xs-6" style="margin-top: -15px">
            <div class="d-flex">
              <h1 class="">
                NETWORK DESIGN
                <img
                  class="ml-2"
                  style="margin-bottom: -5px; width: 40px; height: 40px"
                  src="https://amaze-assets.s3.us-west-1.amazonaws.com/files/networks/2024_2025_NECLN/NetworkDesign-Icon.svg"
                />
              </h1>
              <div></div>
            </div>
            <p class="text-primary-3 pa-0 my-1">
              Networks hosted by the Center for Education Services are guided by
              three additional design tenets:
            </p>
            <h2 class="pa-0 my-2">Membership</h2>
            <p class="pa-0 my-1">
              Networks are communities of practice that are led by members who
              share common interests and challenges.
            </p>
            <h2 class="pa-0 my-2">Strong Relationships</h2>
            <p class="pa-0 my-1">
              Network activities cultivate intentional bonds and bridges among
              members of the community that extend beyond formal convenings.
            </p>
            <h2 class="pa-0 my-2">Environmental Influence</h2>
            <p class="pa-0 my-1">
              Members collaborate to influence the environment in which they
              operate through collective advocacy.
            </p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<style lang="scss" scoped>
#network {
  div {
    .flex {
      vertical-align: middle;
      align-content: center;
    }
  }
  .h2, h2 {
      color: #005295;
      font-family: museo-sans, sans-serif;
      font-size: 22px;
      font-weight: 500;
      line-height: 30px;
  }

  .h1, h1 {
      color: #005295;
      font-size: 28px;
      font-weight: 900;
      line-height: 38px;
  }

  .text-primary-3 {
      color: #c9510c !important;
  }
}
</style>
<script>
export default {
  data() {
    return {};
  }
};
</script>
